import { isServer } from '@flex-packages/utils';
import { useEffect, useLayoutEffect } from 'react';

const useIsomorphicLayoutEffect = isServer() ? useEffect : useLayoutEffect;

export { useIsomorphicLayoutEffect as default };
//# sourceMappingURL=useIsomorphicLayoutEffect.mjs.map
